import { render, staticRenderFns } from "./column-component.vue?vue&type=template&id=f0b28a42&"
import script from "./column-component.vue?vue&type=script&lang=js&"
export * from "./column-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports